import { FC } from 'react';
import placeholder from './placeholder.webp';
import { CircularProgress } from '@mui/material';
import { cx } from '@emotion/css';

type Props = {
  hidden: boolean;
};

export const Placeholder: FC<Props> = ({ hidden }) => (
  <div
    className={cx(
      'absolute z-10 w-full h-full transition-opacity pointer-events-none',
      {
        'opacity-0': hidden,
        'opacity-100': !hidden,
      }
    )}
  >
    <img
      src={placeholder}
      data-testid="placeholder-img"
      alt=""
      className="w-full h-full"
    />
    <div className="absolute flex justify-center items-center w-full h-full top-0 left-0">
      <CircularProgress
        sx={{ color: '#333' }}
        size={40}
        thickness={5}
        className="mb-4"
      />
    </div>
  </div>
);
